import {_} from 'i18n'
import React from 'react'

import {ContainerHeader, DetailContainer, Paper} from '../styles'

var groupBy = function (xs, key) {
  return xs.reduce(function (rv, x) {
    ;(rv[x[key]] = rv[x[key]] || []).push(x)
    return rv
  }, {})
}

const ProposalAttachments = ({multimedia}) => {
  const grouped = groupBy(multimedia, 'type')
  return (
    <Paper>
      <ContainerHeader>{_`Arquivos Sobre a Oportunidade`}</ContainerHeader>
      <DetailContainer>
        {grouped['image'] ? (
          <div>
            <span className="secundary-title">{_`Fotos`}</span>
            <br />
            <br />
            <ul className="image-files">
              {grouped['image'].map((file, index) => (
                <a key={index} href={file.path} target="_blank" rel="noopener noreferrer">
                  <li style={{backgroundImage: `url(${file.path})`, backgroundSize: 'cover'}}></li>
                </a>
              ))}
            </ul>
          </div>
        ) : (
          <big>{_`Oportunidade sem arquivos cadastrados`}</big>
        )}
      </DetailContainer>
    </Paper>
  )
}

export default ProposalAttachments
